module.exports = __webpack_public_path__ + "img/supplier.ee1e2e47.svg";